module.exports = __webpack_public_path__ + "static/img/liu4.71d8316.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/liu4.png
// module id = bHDh
// module chunks = 3